import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const CheckIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        className="filled"
        d="m 10.44898,25.253429 -1.9582118,-1.958218 -1.9651943,1.951233 -3.7584144,3.732172 -1.97916534,1.964962 1.97217964,1.972188 14.7959292,14.795976 1.964954,1.965201 1.965195,-1.965201 31.762267,-31.762131 1.964954,-1.965202 -1.964954,-1.9652 L 49.516359,8.2870828 47.552127,6.3228447 45.58693,8.2861678 19.52202,34.3265 Z"
      />
    </SvgIcon>
  );
};

export default CheckIcon;
